// extracted by mini-css-extract-plugin
export default {"page":"page_page__jJ+m8","main":"page_main__BSkhU","primary":"page_primary__DFLyE","secondary":"page_secondary__-mAjg","footer":"page_footer__k-5wd"};